import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useConfigContext, useCustomerDetailContext } from '@/hoc';
import { StarBorderIcon, StarIcon } from '../icons';
import { Button } from '../ui';
export var JobActions = function (_a) {
    var details = _a.details, isMyJobs = _a.isMyJobs, isPublishJobOnlyForVendors = _a.isPublishJobOnlyForVendors, handleAppliedJob = _a.handleAppliedJob, applyJob = _a.applyJob, setApplyModalVisible = _a.setApplyModalVisible, setSaveModalVisible = _a.setSaveModalVisible, saveJob = _a.saveJob, getBackId = _a.getBackId, setVariableForModal = _a.setVariableForModal, setSelectedJobId = _a.setSelectedJobId, _b = _a.className, className = _b === void 0 ? '' : _b, applyButtonVariant = _a.applyButtonVariant, saveButtonVariant = _a.saveButtonVariant;
    var customerDetail = useCustomerDetailContext().customerDetail;
    var jobCardConfiguration = useConfigContext().config.jobCard;
    if (isPublishJobOnlyForVendors)
        return null;
    return (_jsxs("div", { className: "flex gap-2 items-center ".concat(className), children: [!!(jobCardConfiguration === null || jobCardConfiguration === void 0 ? void 0 : jobCardConfiguration.allowApplyJob) && (_jsx(Button, { id: 'apply-job-btn', variant: applyButtonVariant || (details.isApplied ? 'dangerSecondary' : 'secondary'), size: 'sm', className: 'rounded-md py-1 h-fit w-full', onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    if (customerDetail) {
                        if (isMyJobs) {
                            details.isApplied ? handleAppliedJob(details.jobId) : applyJob(details.jobId);
                        }
                        else {
                            applyJob(details.jobId);
                        }
                    }
                    else {
                        setApplyModalVisible(true);
                        setSelectedJobId(details.jobId);
                    }
                }, children: details.isApplied ? 'Withdraw' : 'Apply' }, details.jobId + 'apply-btn')), !!(jobCardConfiguration === null || jobCardConfiguration === void 0 ? void 0 : jobCardConfiguration.allowSaving) && (_jsx(Button, { variant: saveButtonVariant || 'outline', size: 'sm', className: '!border-none rounded-md py-1 h-fit w-full', disabled: !isMyJobs && details.isSaved, id: 'save-job-btn', onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    if (customerDetail) {
                        !details.isSaved ? saveJob(details.jobId) : getBackId(details.jobId);
                    }
                    else {
                        setSaveModalVisible(true);
                        setVariableForModal('Save Job');
                    }
                }, rightIcon: (details === null || details === void 0 ? void 0 : details.isSaved) ? _jsx(StarIcon, {}) : _jsx(StarBorderIcon, {}), children: details.isSaved ? 'Unsave' : 'Save' }, details.jobId + 'save-btn'))] }));
};
